"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleName = void 0;
/**
 * Enum representing the names of available product modules.
 * Used to identify different modules within the product package system.
 */
var ModuleName;
(function (ModuleName) {
    ModuleName["AppointmentsStandard"] = "AppointmentsStandard";
    ModuleName["AppointmentsRecap"] = "AppointmentsRecap";
    ModuleName["TeamChat"] = "TeamChat";
})(ModuleName = exports.ModuleName || (exports.ModuleName = {}));
//# sourceMappingURL=ModuleName.js.map